import { ValidationMessageModel } from './validation-message-model';
import { enumBondType } from '@data-layer/enums/common';

export class BondModel {
  public suretyCode: string;
  public referenceNumber: string;
  public validationMessages?: [{ [key: string]: ValidationMessageModel }];
  public type: enumBondType;
  public bondAmount?: number; // entry-summary

  constructor(bond?: Partial<BondModel>) {
    if (bond) {
      Object.assign(this, bond);
    }
  }
}
